import LinksActions from '../../../actions/LinksActions';

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        LinksActions.getListLinks(params, (response) => {
            if(response.items) {
                success && success(response.items[0]);
            } else {
                success && success(response[0]);
            }
        }, {});
    },

    updateShortUrl(params, t, onSuccess, onError) {
        LinksActions.updateShortUrl(params).then(data => {
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    },

    getShortUrl(params, success) {
        LinksActions.getShortUrl(params, (response) => {
            let url = response.response.url ? response.response.url : response.url;
            success && success(url);
        }, {});
    },

    getShortenerDomainList(params, success) {
        LinksActions.getShortenerDomainList(params, (response) => {
            let list = response.response.list ? response.response.list : response.list;
            success && success(list);
        }, {});
    },

    getQRCode(params, success) {
        LinksActions.getQRCode(params, (response) => {
            let result = {
                qr: response.response.qr ? response.response.qr : response.qr,
                mime: response.response.mime ? response.response.mime : response.mime
            }

            success && success(result);
        }, {});
    },
};
